module.exports = __webpack_public_path__ + "static/ProximaNova-Regular-1fc524a22c99e8d63393ecfe238e3d35.ttf";